// extracted by mini-css-extract-plugin
var _1 = "DiscountRow_discountName__KgNK6";
var _2 = "DiscountRow_discountValue__WMhyK";
export { _1 as "discountName", _2 as "discountValue" }
